import React, {useEffect, useState} from 'react';
import Input from '../../Input';
import CustomSelect from '../../CustomSelect';
import {
  useUpdateCorporateMutation,
} from '../../../store/builder/inspections.api';
import {useErrorHandler} from '../../../global/ErrorsHandler';
import {setLoader} from '../../../store/builder/reducer';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import {validationEmail} from '../../../global/validate';
import Checkbox from '../../Checkbox';
import {useTranslation} from '../../../hooks/useTranslation';
import {useSelector} from 'react-redux';

const CorporateEditModal = ({
  exit,
  currentCorporateAccount,
  getCorporateListFunc,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [timeOptions, setTimeOptions] = useState([
    {
      label: '12:00 AM',
      value: 0,
    },
    {
      label: '1:00 AM',
      value: 60,
    },
    {
      label: '2:00 AM',
      value: 120,
    },
    {
      label: '3:00 AM',
      value: 180,
    },
    {
      label: '4:00 AM',
      value: 240,
    },
    {
      label: '5:00 AM',
      value: 300,
    },
    {
      label: '6:00 AM',
      value: 360,
    },
    {
      label: '7:00 AM',
      value: 420,
    },
    {
      label: '8:00 AM',
      value: 480,
    },
    {
      label: '9:00 AM',
      value: 540,
    },
    {
      label: '10:00 AM',
      value: 600,
    },
    {
      label: '11:00 AM',
      value: 660,
    },
    {
      label: '12:00 PM',
      value: 720,
    },
    {
      label: '1:00 PM',
      value: 780,
    },
    {
      label: '2:00 PM',
      value: 840,
    },
    {
      label: '3:00 PM',
      value: 900,
    },
    {
      label: '4:00 PM',
      value: 960,
    },
    {
      label: '5:00 PM',
      value: 1020,
    },
    {
      label: '6:00 PM',
      value: 1080,
    },
    {
      label: '7:00 PM',
      value: 1140,
    },
    {
      label: '8:00 PM',
      value: 1200,
    },
    {
      label: '9:00 PM',
      value: 1260,
    },
    {
      label: '10:00 PM',
      value: 1320,
    },
    {
      label: '11:00 PM',
      value: 1380,
    },
  ]);
  const {t} = useTranslation();
  
  const waterRating = [
    {
      value: 'A',
      label: t('corporateEditModal.ratings.water.bright'),
    },
    {
      value: 'B',
      label: t('corporateEditModal.ratings.water.hazy'),
    },
    {
      value: 'C',
      label: t('corporateEditModal.ratings.water.cloudy'),
    },
    {
      value: 'D',
      label: t('corporateEditModal.ratings.water.wet'),
    },
    {
      value: 'E',
      label: t('corporateEditModal.ratings.water.surfactants'),
    },
  ];
  
  const solidRating = [
    {
      value: 1,
      label: t('corporateEditModal.ratings.solid.clean'),
    },
    {
      value: 2,
      label: t('corporateEditModal.ratings.solid.slight'),
    },
    {
      value: 3,
      label: t('corporateEditModal.ratings.solid.particulate'),
    },
    {
      value: 4,
      label: t('corporateEditModal.ratings.solid.dirty'),
    },
  ];
  const [state, setState] = useState({
    title: null,
    timezone: null,
    admin_email: null,
    start_day_minutes: null,
    sump_water_rating: null,
    sump_solid_rating: null,
    nozzle_fueling_pressure: null,
    sump_trend_alert: null,
    has_upstream_tests: false,
    allow_daily_dec_equipment: false,
    allow_generating_decommissioned: false,
    partial_inspections_notification: false,
    force_sso: false,
    inactivity_timeout_mobile: 0,
    inactivity_timeout_web: 0,
    is_pin_enabled: false,
    pin_require_seconds: null,
    partial_inspections_notification_minutes: 0,
  });

  const [
    updateCorporate,
    {
      error: updateCorporateError,
      isLoading: updateCorporateIsLoading,
      isSuccess: updateCorporateIsSuccess,
      isError: updateCorporateIsError,
    },
  ] = useUpdateCorporateMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    updateCorporateError,
  ]);

  useEffect(() => {
    if (updateCorporateIsLoading) {
      dispatch(setLoader(true));
    }
    if (updateCorporateIsSuccess) {
      dispatch(setLoader(false));
      exit();
      toast.success(t('corporateEditModal.messages.successfullyUpdated'));
      getCorporateListFunc();
    }
    if (updateCorporateIsError) {
      dispatch(setLoader(false));
    }
  }, [updateCorporateIsLoading]);

  useEffect(() => {
    if (currentCorporateAccount) {
      setState(old => ({
        ...old,
        title: currentCorporateAccount?.title,
        // timezone: currentCorporateAccount?.timezone,
        admin_email: currentCorporateAccount?.admin_email,
        start_day_minutes: currentCorporateAccount?.start_day_minutes,
        sump_water_rating: currentCorporateAccount?.sump_water_rating,
        sump_solid_rating: currentCorporateAccount?.sump_solid_rating,
        nozzle_fueling_pressure:
          currentCorporateAccount?.nozzle_fueling_pressure,
        sump_trend_alert: currentCorporateAccount?.sump_trend_alert,
        has_upstream_tests: !!currentCorporateAccount?.has_upstream_tests,
        allow_daily_dec_equipment: !!currentCorporateAccount?.allow_daily_dec_equipment,
        allow_generating_decommissioned: !!currentCorporateAccount?.allow_generating_decommissioned,
        inactivity_timeout_mobile: currentCorporateAccount?.inactivity_timeout_mobile ?? 0,
        inactivity_timeout_web: currentCorporateAccount?.inactivity_timeout_web ?? 0,
        is_pin_enabled: !!currentCorporateAccount?.is_pin_enabled,
        pin_require_seconds: currentCorporateAccount?.pin_require_seconds ?? null,
        partial_inspections_notification: !!currentCorporateAccount?.partial_inspections_notification,
        partial_inspections_notification_minutes: currentCorporateAccount?.partial_inspections_notification_minutes ?? 0,
        force_sso: !!currentCorporateAccount?.force_sso,
      }));
    }
  }, [currentCorporateAccount]);

  const handleInput = e => {
    setState(old => ({...old, [e.target.name]: e.target.value}));
  };

  const handleCheckbox = e => {
    setState(old => ({...old, has_upstream_tests: e.target.checked}));
  };

  const handleAllowDailyDecEquipment = e => {
    setState(old => ({...old, allow_daily_dec_equipment: e.target.checked}));
  };

  const handleAllowGeneratingDecommissioned = e => {
    setState(old => ({...old, allow_generating_decommissioned: e.target.checked}));
  };

  const handlePartialInspectionsNotification = e => {
    setState(old => ({...old, partial_inspections_notification: e.target.checked}));
  };

  const handleForceSso = e => {
    setState(old => ({...old, force_sso: e.target.checked}));
  };

  const handleIsPinEnabled = e => {
    setState(old => ({...old, is_pin_enabled: e.target.checked}));
  };

  // The PIN has to be asked before the session is dropped, so it must stay
  // under the mobile timeout. The PIN delay is in seconds while the timeout is
  // in minutes; a mobile timeout of 0 never expires, so there is nothing to
  // compare against.
  const pinRequireSeconds = Number(state?.pin_require_seconds);
  const mobileTimeout = Number(state?.inactivity_timeout_mobile);
  const pinRequireSecondsError = !state?.is_pin_enabled
    ? null
    : !state?.pin_require_seconds || !(pinRequireSeconds >= 1)
      ? t('modal.pinRequireSecondsRequired')
      : mobileTimeout > 0 && pinRequireSeconds >= mobileTimeout * 60
        ? t('modal.pinRequireSecondsLessThanMobileTimeout')
        : null;

  const update = event => {
    event.preventDefault();
    if (pinRequireSecondsError) {
      toast.error(pinRequireSecondsError);
      return;
    }
    if (
      state.nozzle_fueling_pressure &&
      // state.timezone &&
      // state.timezone !== 'utc' &&
      state.start_day_minutes !== null &&
      state.sump_water_rating &&
      state.sump_solid_rating &&
      state.title?.length >= 3 &&
      validationEmail(state.admin_email)
    ) {
      updateCorporate({
        body: {
          title: state.title,
          // timezone: state.timezone,
          admin_email: state.admin_email,
          start_day_minutes: state.start_day_minutes,
          sump_water_rating: state.sump_water_rating,
          sump_solid_rating: state.sump_solid_rating?.toString(),
          nozzle_fueling_pressure: state.nozzle_fueling_pressure,
          sump_trend_alert: state.sump_trend_alert,
          has_upstream_tests: state.has_upstream_tests ? 1 : 0,
          allow_daily_dec_equipment: state.allow_daily_dec_equipment ? 1 : 0,
          allow_generating_decommissioned: state.allow_generating_decommissioned ? 1 : 0,
          inactivity_timeout_mobile: +state.inactivity_timeout_mobile ?? 0,
          inactivity_timeout_web: +state.inactivity_timeout_web ?? 0,
          is_pin_enabled: state.is_pin_enabled ? 1 : 0,
          ...(state.is_pin_enabled
            ? {pin_require_seconds: +state.pin_require_seconds}
            : {}),
          partial_inspections_notification: state.partial_inspections_notification ? 1 : 0,
          partial_inspections_notification_minutes: +state.partial_inspections_notification_minutes ?? 0,
          force_sso: !!state.force_sso,
        },
        id: currentCorporateAccount?.id,
      });
    }
    // if (!state.sump_trend_alert) {
    //   toast.error('Sump trend alert is required')
    // }
    if (!state.nozzle_fueling_pressure) {
      toast.error(t('corporateEditModal.messages.nozzleFuelingPressureRequired'));
    }
    // if (!state.timezone || state.timezone === null || state.timezone === undefined || state.timezone === 'utc') {
    //   toast.error('Timezone is required')
    // }
    if (state.start_day_minutes === null) {
      toast.error(
        t('corporateEditModal.messages.startDayMinutesRequired'),
      );
    }
    if (!state.sump_water_rating) {
      toast.error(t('corporateEditModal.messages.sumpWaterRatingRequired'));
    }
    if (!state.sump_solid_rating) {
      toast.error(t('corporateEditModal.messages.sumpSolidRatingRequired'));
    }
    if (state.title?.length < 3) {
      toast.error(t('corporateEditModal.messages.titleMinLength'));
    }
    if (!validationEmail(state.admin_email)) {
      toast.error(t('corporateEditModal.messages.invalidEmail'));
    }
  };

  return (
    <div className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('corporateEditModal.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div className={`modal__content-body height`}>
          <Input
            containerWidth={'100%'}
            id='title'
            name='title'
            placeholder={t('corporateEditModal.corporateNamePlaceholder')}
            label={t('corporateEditModal.corporateName')}
            type={'text'}
            defaultValue={currentCorporateAccount?.title}
            onChange={handleInput}
          />
          <Input
            containerWidth={'100%'}
            id='admin_email'
            name='admin_email'
            placeholder={t('corporateEditModal.emailPlaceholder')}
            label={t('corporateEditModal.email')}
            type={'email'}
            defaultValue={currentCorporateAccount?.admin_email}
            onChange={handleInput}
          />
          {/*<CustomSelect*/}
          {/*  name={"timezone"}*/}
          {/*  label={"Timezone"}*/}
          {/*  type={"timezone"}*/}
          {/*  maxwidth="100%"*/}
          {/*  options={timezoneOptions}*/}
          {/*  defaultValue={currentCorporateAccount?.timezone?.toString()?.length ?*/}
          {/*    timezoneOptions.filter(el => el.value === currentCorporateAccount?.timezone)[0]*/}
          {/*    : null}*/}
          {/*  onChange={handleInput}*/}
          {/*/>*/}
          <div style={{marginBottom: 16}}>
            <CustomSelect
              label={t('corporateEditModal.whenDoYouWantNewInspectionsToGenerate')}
              options={timeOptions}
              name={'start_day_minutes'}
              // onChange={handleStartTime}
              defaultValue={
                currentCorporateAccount?.start_day_minutes?.toString()?.length
                  ? timeOptions.filter(
                      el =>
                        el.value === currentCorporateAccount?.start_day_minutes,
                    )[0]
                  : null
              }
              onChange={handleInput}
              placeholder={t('corporateEditModal.whenDoYouWantNewInspectionsToGeneratePlaceholder')}
            />
          </div>
          <div style={{marginBottom: 16}}>
            <CustomSelect
              label={t('corporateEditModal.sumpWaterRating')}
              options={waterRating}
              name={'sump_water_rating'}
              onChange={handleInput}
              defaultValue={
                currentCorporateAccount?.sump_water_rating?.toString()?.length
                  ? waterRating.filter(
                      el =>
                        el.value === currentCorporateAccount?.sump_water_rating,
                    )[0]
                  : null
              }
              placeholder={t('corporateEditModal.sumpWaterRatingPlaceholder')}
            />
          </div>
          <div style={{marginBottom: 16}}>
            <CustomSelect
              label={t('corporateEditModal.sumpSolidRating')}
              placeholder={t('corporateEditModal.sumpSolidRatingPlaceholder')}
              name={'sump_solid_rating'}
              defaultValue={
                currentCorporateAccount?.sump_solid_rating
                  ? solidRating.filter(
                      el =>
                        el.value == currentCorporateAccount?.sump_solid_rating,
                    )[0]
                  : ''
              }
              onChange={handleInput}
              options={solidRating}
              maxwidth={'100%'}
            />
          </div>
          <Input
            containerWidth={'100%'}
            label={t('corporateEditModal.nozzleFuelingPressure')}
            placeholder={t('corporateEditModal.nozzleFuelingPressurePlaceholder')}
            name={'nozzle_fueling_pressure'}
            defaultValue={currentCorporateAccount?.nozzle_fueling_pressure}
            onChange={handleInput}
          />
          <Input
            label={t('corporateEditModal.sumpTrendAlert')}
            containerWidth={'100%'}
            placeholder={t('corporateEditModal.sumpTrendAlertPlaceholder')}
            name={'sump_trend_alert'}
            defaultValue={currentCorporateAccount?.sump_trend_alert}
            onChange={handleInput}
          />
          <div className='facility-modal__field' style={{marginTop: 16}}>
            <Checkbox
              key={'has_upstream_tests'}
              label={t('corporateEditModal.hasUpstreamTests')}
              id={'has_upstream_tests'}
              checked={state?.has_upstream_tests}
              onChange={handleCheckbox}
            />
          </div>
          <div className='facility-modal__field' style={{marginTop: 16}}>
            <Checkbox
              key={'allow_daily_dec_equipment'}
              label={t('corporateEditModal.enableGenerationOfDailyInspectionsForOutOfServiceEquipment')}
              id={'allow_daily_dec_equipment'}
              checked={state?.allow_daily_dec_equipment}
              onChange={handleAllowDailyDecEquipment}
            />
          </div>

          <div className='facility-modal__field' style={{marginTop: 16}}>
            <Checkbox
              key={'allow_generating_decommissioned'}
              label={t('modal.generateRtsInspectionsForOos')}
              id={'allow_generating_decommissioned'}
              checked={state?.allow_generating_decommissioned}
              onChange={handleAllowGeneratingDecommissioned}
            />
            <Checkbox
              key={'partial_inspections_notification'}
              label={t('modal.partialInspectionsNotification')}
              id={'partial_inspections_notification'}
              checked={state?.partial_inspections_notification}
              onChange={handlePartialInspectionsNotification}
            />
            {
              userInfo?.is_global && currentCorporateAccount?.is_sso_active && (
                <Checkbox
              key={'force_sso'}
              label={'Force SSO'}
              id={'force_sso'}
              checked={state?.force_sso}
              onChange={handleForceSso}
            />
              )
            }
          </div>

          <CustomSelect
            tooltip={false}
            label={t('modal.partialInspectionsNotificationMinutes')}
            options={timeOptions}
            name={'partial_inspections_notification_minutes'}
            onChange={handleInput}
            defaultValue={{
              value: state.partial_inspections_notification_minutes,
              label: timeOptions.find(item => +item?.value === +state.partial_inspections_notification_minutes)?.label,
            }}
            disabled={!state.partial_inspections_notification}
          />
          <div style={{marginTop: 16}}>
            <Input
            id='inactivity_timeout_mobile'
            name='inactivity_timeout_mobile'
            placeholder={t('modal.inactivityTimeoutMobile')}
            label={t('modal.inactivityTimeoutMobile')}
            type={'number'}
            onChange={handleInput}
            containerWidth={'100%'}
            value={state.inactivity_timeout_mobile}
          />
          </div>
          <div className='facility-modal__field' style={{marginTop: 16}}>
            <Checkbox
              key={'is_pin_enabled'}
              label={t('modal.isPinEnabled')}
              id={'is_pin_enabled'}
              checked={!!state?.is_pin_enabled}
              onChange={handleIsPinEnabled}
            />
          </div>
          <Input
            id='pin_require_seconds'
            name='pin_require_seconds'
            placeholder={t('modal.pinRequireSeconds')}
            label={t('modal.pinRequireSeconds')}
            type={'number'}
            onChange={handleInput}
            containerWidth={'100%'}
            value={state?.pin_require_seconds ?? ''}
            disabled={!state?.is_pin_enabled}
          />
          {pinRequireSecondsError && (
            <span
              style={{
                color: '#EB5757',
                fontSize: 12,
                marginTop: 4,
                display: 'block',
              }}
            >
              {pinRequireSecondsError}
            </span>
          )}
          <Input
            id='inactivity_timeout_web'
            name='inactivity_timeout_web'
            placeholder={t('modal.inactivityTimeoutWeb')}
            label={t('modal.inactivityTimeoutWeb')}
            type={'number'}
            onChange={handleInput}
            containerWidth={'100%'}
            value={state.inactivity_timeout_web}
          />
        </div>

        <div className='modal__content-bottom'>
          <button className='close' onClick={exit}>
            {t('corporateEditModal.cancel')}
          </button>
          <button className='save' onClick={update}>
            {t('corporateEditModal.save')}
          </button>
        </div>
      </div>
      <div className='modal__bg' onClick={exit}></div>
    </div>
  );
};

export default CorporateEditModal;
